const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
const A4_FREQ = 440;
const A4_MIDI = 69;

export interface NoteInfo {
  note: string;
  octave: number;
  fullName: string;
  frequency: number;
  cents: number;
  midi: number;
}

export function frequencyToNote(freq: number): NoteInfo {
  const semitones = 12 * Math.log2(freq / A4_FREQ);
  const midi = Math.round(A4_MIDI + semitones);
  const cents = Math.round((semitones - (midi - A4_MIDI)) * 100);

  const noteIndex = midi % 12;
  const octave = Math.floor(midi / 12) - 1;
  const note = NOTE_NAMES[noteIndex];

  return {
    note,
    octave,
    fullName: `${note}${octave}`,
    frequency: noteToFrequency(midi),
    cents,
    midi,
  };
}

export function noteToFrequency(midi: number): number {
  return A4_FREQ * Math.pow(2, (midi - A4_MIDI) / 12);
}

export function noteNameToMidi(name: string, octave: number): number {
  const idx = NOTE_NAMES.indexOf(name);
  if (idx === -1) return -1;
  return (octave + 1) * 12 + idx;
}

// Transpose a reference track by semitones
export function transposeFrequency(freq: number, semitones: number): number {
  return freq * Math.pow(2, semitones / 12);
}

// Human-readable pitch accuracy label
export function pitchAccuracyLabel(cents: number): string {
  const abs = Math.abs(cents);
  if (abs <= 5) return 'Perfect';
  if (abs <= 15) return cents > 0 ? 'Sharp' : 'Flat';
  if (abs <= 35) return cents > 0 ? 'Too Sharp' : 'Too Flat';
  return cents > 0 ? 'Way Sharp' : 'Way Flat';
}

// Color for cents deviation: green → yellow → red
export function centsToColor(cents: number): string {
  const abs = Math.abs(cents);
  if (abs <= 10) return '#4ade80';
  if (abs <= 25) return '#facc15';
  return '#f87171';
}

export { NOTE_NAMES };
